import InputSlider from "./InputSlider";
export default InputSlider;